import {
  Dialog,
  Metadata,
  useNumberFormat,
  useTranslations,
  useUrlParamsValueToString,
} from "@harea/component";
import moment from "moment";
import { useCallback } from "react";
import { useGraphqlQuery } from "@harea/component";
import { useNavigate, useParams } from "react-router-dom";
import { TLate } from "@harea/component";
import { LateQuery } from "../../../../../queries/LateQuery";

const formatMinutesToHHmm = (minutes?: number) => {
  if (minutes === null || minutes === undefined) return "-";
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
};

const LateDetailsContainer = () => {
  const [DETAILS, LATE_DATE, ARRIVAL, DELAY, REASON, EMPLOYEE, PAYROLL_DEDUCTION_AMOUNT] =
    useTranslations(i18n);
  const formatCurrency = useNumberFormat({ style: "currency", currency: "MGA" });
  const { id } = useParams();
  const navigate = useNavigate();
  const urlParamsToString = useUrlParamsValueToString();

  const { data } = useGraphqlQuery<LateQuery, TLate>(
    new LateQuery({ id: parseInt(id!) }),
    { suspense: true }
  );

  const handleClose = useCallback(() => {
    navigate(`..?${urlParamsToString}`);
  }, [id, urlParamsToString, navigate]);

  return (
    <Dialog
      open={id !== undefined}
      className="max-w-3xl"
      title={DETAILS}
      onClose={handleClose}
    >
      <div className="flex flex-col gap-4 p-4">
        <Metadata
          label={EMPLOYEE}
          value={<span className="font-semibold">{data?.employee?.fullName ?? "-"}</span>}
        />
        <Metadata
          label={LATE_DATE}
          value={
            data?.lateDate
              ? moment(data.lateDate).format("DD/MM/YYYY")
              : "-"
          }
        />
        <Metadata label={ARRIVAL} value={data?.actualStartArrival ?? "-"} />
        <Metadata label={DELAY} value={formatMinutesToHHmm(data?.timeDelay)} />
        <Metadata label={REASON} value={data?.reason ?? "-"} />
        {(data as any)?.payrollDeductionAmount != null && (
          <Metadata
            label={PAYROLL_DEDUCTION_AMOUNT}
            value={
              <span className="font-medium text-danger">
                {formatCurrency((data as any)?.payrollDeductionAmount)}
              </span>
            }
          />
        )}
      </div>
    </Dialog>
  );
};

const i18n = [
  "std_details",
  "std_late_date",
  "std_arrival_time",
  "std_delay",
  "std_reason",
  "std_employee",
  "Harea.Project.DayOff.Detail.PayrollDeductionAmount",
];

export default LateDetailsContainer;
